import Api from '@/api'
import TimesheetsTotalResponseFormatter from '@/utilities/timesheets/total/TimesheetsTotalResponseFormatter'
import TimesheetsTotalTimeConverter from '@/utilities/timesheets/total/TimesheetsTotalTimeConverter'
import JsonToCsv from '@/utilities/helper/JsonToCsv'

const api = new Api().timesheets().approval()

export default {
  async fetchSummary({ commit }, { dateFrom, dateTo }) {
    try {
      const response = await api.summary(dateFrom, dateTo)

      const formatter = new TimesheetsTotalResponseFormatter(response)

      commit('setSummary', new TimesheetsTotalTimeConverter().handle(formatter.summary()))
      commit('setSettings', formatter.settings())
    } catch (err) {
      commit(
        'Dashboard/setFeedback',
        {
          message: err,
          errors: 500,
        },
        { root: true },
      )
    }
  },

  async fetchUsers({ commit }, date) {
    try {
      const { data } = await api.users(date)
      commit('Dashboard/setFeedback', data.data, { root: true })
      commit('setUsers', data.data.users)
    } catch (err) {
      commit(
        'Dashboard/setFeedback',
        {
          message: err,
          errors: 500,
        },
        { root: true },
      )
    }
  },

  async updateStatus({ commit }, payload) {
    try {
      const { data } = await api.updateStatus(payload)

      data.data.users.forEach(user => {
        commit('updateUser', user)
      })

      commit('Dashboard/setFeedback', data.data, { root: true })
    } catch (err) {
      commit(
        'Dashboard/setFeedback',
        {
          message: err,
          errors: 500,
        },
        { root: true },
      )
    }
  },

  async exportDocument({ commit }, { dateFrom, dateTo }) {
    try {
      const resp = await api.exportDocument(dateFrom, dateTo)

      const jsonToCsv = new JsonToCsv(resp.data.data)
      const fileURL = window.URL.createObjectURL(new Blob([jsonToCsv.fetch()]))
      const fileLink = document.createElement('a')
      fileLink.href = fileURL
      fileLink.setAttribute('download', `timesheets_approval_${dateFrom}-${dateTo}.csv`)
      document.body.appendChild(fileLink)
      fileLink.click()

      return resp
    } catch (err) {
      commit(
        'Dashboard/setFeedback',
        {
          message: err,
          errors: 500,
        },
        { root: true },
      )
    }
  },
}
